export default __webpack_public_path__ + "static/media/girar_celular_eng.b94c785a.jpg";